import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { has, isEqual, set, remove, get } from 'lodash/fp'
import { useSelector, useDispatch, ReactReduxContext } from 'react-redux'
import { useLocation, useHistory } from 'react-router-dom'
import { Flex } from 'rebass'
import Button from 'e-submission/components/Button'
import { FormFeedback, ModalHeader, ModalBody } from 'reactstrap'
import _getOr from 'lodash/fp/getOr'
import _ from 'lodash'

import { createSection } from 'e-submission/domain/data-model/form/utils'
import {
  removeError,
  resetValidation,
  verifyPayment,
  changePaymentMethod,
  checkPaymentStatus,
  checkQrPaying,
} from 'e-submission/apps/actions'
import { getErrors, isSectionValid, getCurrentAppId, getCurrentApp } from 'e-submission/apps/selectors'
import Dialog from 'e-submission/components/Dialog'
import Icon from 'e-submission/components/Icon'
import Content from 'e-submission/components/Layout/Content'
import CreditCardConsent from 'e-submission/components/Form/Payment/creditCardConsent'
import CreditCardPaymentMethod from 'e-submission/components/Form/Payment/creditCardPaymentMethod'

import { getToggles } from 'quick-quote/feature-toggles'
import NumberInput from 'react-number-format'
import SendLinkSmsEmail from 'e-submission/containers/Dialog/SendLinkSmsEmail'
import { isSelectedRemoteSelling, isPayerInfoValid } from 'e-submission/domain/data-model/form/selectors'

const removeFromArray = remove.convert({
  immutable: false,
})

export const CybersourceDisplayCreditCardPaymentFormButton = ({
  disabled,
  className,
  toggleModal,
  isModalOpen,
  value,
  checked,
  onOpen,
  onClick,
  policyId,
  product,
  onVerifyPayment,
  selectedModelFactorLabel,
  handleConsentValidation,
  isDisabledPaymentButton,
  handleCheckMethod,
  handleCheckCreditcardRelationShip,
  closeModal,
  onOpenQuicklink,
  onResendQuicklink,
  isOpenQuickpayModal,
  app,
  state,
  onChangePaymentMethod,
  creditCardPaymentMethod,
  creditCardRelationship,
  quickpayDetail,
}) => {
  const { status, isSendLink, expiredDateTime } = quickpayDetail
  const isEnabledECBRSystemization = getToggles().ENABLE_ECBR_SYSTEMIZATION

  const isRemoteSelling = isSelectedRemoteSelling(app)
  const isNotRemoteSelling = !creditCardRelationship
  const isNotSelectedAllOptions = isEnabledECBRSystemization
    ? !(creditCardPaymentMethod && isPayerInfoValid(app, state))
    : !(creditCardPaymentMethod && creditCardRelationship)

  return (
    <div className={className}>
      {checked || status === 'SUCCESS' ? (
        <div className="form-group has-success">
          <FormFeedback className="validation-message attached-icon">
            <p>ชําระเงินเรียบร้อย</p>
          </FormFeedback>
        </div>
      ) : (
        <div>
          {getToggles().ENABLE_QUICKLINK_PAYMENT ? (
            <Flex mt={10}>
              <CreditCardPaymentMethod
                data-testid="creditcard-payment-method"
                handleCheckMethod={handleCheckMethod}
                creditCardMethod={creditCardPaymentMethod}
                isSendLink={isSendLink}
                isRemoteSelling={isRemoteSelling}
              />
            </Flex>
          ) : null}
          {getToggles().ENABLE_CREDIT_CARD_RELATIONSHIP ? (
            <Flex mt={10}>
              <CreditCardConsent
                data-testid="creditcard-consent"
                handleConsentValidation={handleConsentValidation}
                handleCheckCreditcardRelationShip={handleCheckCreditcardRelationShip}
                creditCardRelationship={creditCardRelationship}
                isSendLink={isSendLink}
              />
            </Flex>
          ) : null}

          {getToggles().ENABLE_QUICKLINK_PAYMENT ? (
            <div data-testid="quicklink-button" id="quicklink-status">
              {!isSendLink && !expiredDateTime ? (
                <Flex width={1} justify="center" mt={10}>
                  <Button id="quicklink-button" disabled={isNotSelectedAllOptions} onClick={onOpenQuicklink}>
                    ยืนยัน
                  </Button>
                </Flex>
              ) : (
                <Flex column width={1} align="center" mt={10}>
                  <Button className="btn-col" onClick={onVerifyPayment}>
                    ตรวจสอบการชำระเงิน
                  </Button>
                  {!_.isEmpty(status) && (
                    <Button className="btn-col" outline onClick={onResendQuicklink}>
                      สร้างลิงก์ชำระเงินอีกครั้ง
                    </Button>
                  )}
                  {!_.isEmpty(status) && (
                    <Button className="btn-col" outline onClick={onChangePaymentMethod}>
                      เปลี่ยนวิธีการชำระเบี้ย
                    </Button>
                  )}
                  {expiredDateTime ? (
                    <FormFeedback className="info-message attached-icon">
                      <p>
                        ลิงก์ในการชำระเบี้ยของท่านจะหมดอายุภายในวันที่ {expiredDateTime.date} เวลา{' '}
                        {expiredDateTime.time} น.
                        <br />
                        หรือภายใน 60 นาทีหลังจากได้รับข้อความกรุณาตรวจสอบการชำระเบี้ยผู้เอาประกัน
                      </p>
                    </FormFeedback>
                  ) : null}
                </Flex>
              )}
            </div>
          ) : (
            <Flex mt={10} data-testid="cybersource-button">
              <Flex width={1} justify="flex-end">
                <Button disabled={isDisabledPaymentButton} onClick={onOpen}>
                  ชำระ
                </Button>
              </Flex>
            </Flex>
          )}
        </div>
      )}
      <SendLinkSmsEmail
        data-testid="quicklink-form-modal"
        isOpen={isOpenQuickpayModal}
        onExit={closeModal}
        currentApp={app}
      />
      <Dialog id="payment-form-modal" isOpen={isModalOpen} toggle={toggleModal} className={className}>
        <ModalHeader>
          <div className="btn-left" onClick={toggleModal}>
            <Icon.arrowLeft />
          </div>
          <span>กรุณาตรวจสอบข้อมูลก่อนการชำระเบี้ย</span>
        </ModalHeader>
        <ModalBody>
          <Content>
            <div>
              <div className="modal-title">
                <Icon.cybersource />
              </div>

              <Flex justify="space-between" className="user-fullname-container"></Flex>
              <div className="">
                <Flex justify="space-between">
                  <label className="text-primary">หมายเลขกรมธรรม์</label>
                  <label className="text-primary">{policyId}</label>
                </Flex>
                <Flex justify="space-between">
                  <label className="text-primary">ผลิตภัณฑ์</label>
                  <label className="text-primary">{product}</label>
                </Flex>
                <Flex justify="space-between">
                  <label className="text-primary">งวดการชำระเบี้ยประกันภัย</label>
                  <label className="text-primary">{selectedModelFactorLabel}</label>
                </Flex>

                <hr className="hr-solid-grey" />

                <Flex justify="space-between">
                  <label className="text-primary">
                    <b>จำนวนที่ชำระ</b>
                  </label>
                  <label className="text-primary">
                    <b>
                      <NumberInput
                        value={value}
                        displayType="text"
                        suffix=" THB"
                        thousandSeparator
                        decimalPrecision={2}
                      />
                    </b>
                  </label>
                </Flex>
                <hr className="hr-solid-brand-primary" />
                <label className="text-muted">*หมายเหตุ : ​ชำระกรมธรรม์งวดแรก</label>
              </div>
              <div className="modal-footer">
                <Button disabled={disabled} onClick={onClick}>
                  <span>ยืนยันการชำระเบี้ย</span>
                </Button>
              </div>
            </div>
          </Content>
        </ModalBody>
      </Dialog>
    </div>
  )
}

const StyledDisplayCreditCardPaymentFormButton = styled(CybersourceDisplayCreditCardPaymentFormButton)`
  .cross-icon {
    cursor: pointer;
  }
  .btn-col {
    width: 100%;
    max-width: 237px;
  }
  .info-message {
    width: 100%;
  }
  ${Content} {
    padding: 20px;
  }
  .modal-header {
    .modal-title {
      flex-direction: row;
      display: flex;
    }
    .icon,
    .btn-left {
      z-index: 999;
      cursor: pointer;
      height: 40px;
    }
    span {
      margin-left: -28px;
      flex: 1 1 auto;
    }
  }
  .modal-body {
    .expire-date {
      padding-right: 10px;
    }
    .omise-submit {
      margin-top: 40px;
    }
    span {
      margin-right: 5px;
    }
    .form-container {
      margin-top: 10px;
      .form-group {
        padding: 0;
      }
      input {
        font-size: 1rem;
      }
      input::placeholder {
        color: ${({ theme }) => theme.variables['$color-silver']};
      }
    }
    .omise-logo {
      margin-top: 5px;
    }
  }
`

export const getErrorMessage = (errors) => {
  let errorMessage

  if (has('OMISE_PAYMENT', errors)) {
    const errorCode = get('OMISE_PAYMENT', errors)
    if (errorCode === 'invalid_card') {
      errorMessage = 'หมายเลขบัตรไม่ถูกต้อง'
    } else if (errorCode === 'browser_popup_blocker') {
      errorMessage = 'กรุณาอณุญาตป๊อปอัปเพื่อ OTP'
    } else {
      errorMessage = 'ดำเนินการไม่สำเร็จ กรุณาลองใหม่อีกครั้ง'
    }
  }

  return errorMessage
}

export const addLocalStore = (WrappedComponent) => {
  return function CreditCardWithLocalStore(outerProps) {
    const { fields, startCybs, checked } = outerProps

    const [isModalOpen, setIsModalOpen] = useState(false)
    const location = useLocation()
    const history = useHistory()
    const toggleModal = (e) => {
      if (e) e.preventDefault()
      setIsModalOpen((prev) => !prev)
    }

    const [form, setFormState] = useState({})
    const [isOpenQuickpayModal, setIsOpenQuickpayModal] = useState(false)
    const toggleQuickpayModal = () => setIsOpenQuickpayModal((prev) => !prev)
    const closeModal = () => setIsOpenQuickpayModal(false)

    const [isDisabledPaymentButton, setIsDisabledPaymentButton] = useState(
      !!getToggles().ENABLE_CREDIT_CARD_RELATIONSHIP
    )
    const [isSelectedMethod, setIsSelectedMethod] = useState(undefined)
    const [isSelectedCreditCardRelationShip, setIsSelectedCreditCardRelationShip] = useState(undefined)

    const reduxDispatch = useDispatch()
    const reduxState = useSelector((state) => state)

    const currentAppId = getCurrentAppId(reduxState)
    const app = getCurrentApp(reduxState)
    const errors = getErrors(reduxState)
    const errorMessage = getErrorMessage(errors)
    const quickpayDetail = _getOr({ status: null, isSendLink: false, expiredDateTime: null }, 'quickpayLink', app)
    const creditCardPaymentMethod = _getOr('', 'creditCardMethod', app)
    const creditCardRelationship = _getOr('', 'creditCardRelationship', app)
    const isRemoteSelling = isSelectedRemoteSelling(app)
    const localState = set(['apps', 'byId', currentAppId], _.isEmpty(form) ? app : form, reduxState)
    const disabled = !isSectionValid(reduxState, [createSection(fields)])(form)

    const callbackListRef = useRef([])
    const localStateRef = useRef(localState)
    localStateRef.current = localState
    const rerender = useCallback(() => callbackListRef.current.forEach((cb) => cb()), [])

    const prevCheckedRef = useRef(checked)
    const isModalOpenRef = useRef(isModalOpen)
    isModalOpenRef.current = isModalOpen
    useEffect(() => {
      const prevChecked = prevCheckedRef.current
      if (isModalOpenRef.current && !prevChecked && checked) {
        setIsModalOpen(false)
      }
      prevCheckedRef.current = checked
    }, [checked])

    const handleToggleModal = useCallback(() => {
      if (errorMessage) reduxDispatch(removeError('OMISE_PAYMENT'))
      toggleModal()
    }, [errorMessage, reduxDispatch])

    const onOpen = useCallback(
      (event) => {
        event.stopPropagation()
        reduxDispatch(resetValidation())
        toggleModal()
      },
      [reduxDispatch]
    )

    const onOpenQuicklink = useCallback(
      (event) => {
        event.stopPropagation()
        const method = get('creditCardMethod', app)
        const quickpayRefToken = get('quickpayLink.refToken', app) || ''
        reduxDispatch(checkQrPaying(method, isRemoteSelling, toggleQuickpayModal, toggleModal, quickpayRefToken))
      },
      [app, isRemoteSelling, reduxDispatch]
    )

    const onResendQuicklink = useCallback(
      (event) => {
        event.stopPropagation()
        reduxDispatch(checkPaymentStatus(toggleQuickpayModal))
      },
      [reduxDispatch]
    )

    const onChangePaymentMethod = useCallback(() => reduxDispatch(changePaymentMethod()), [reduxDispatch])
    const onVerifyPayment = useCallback(() => reduxDispatch(verifyPayment()), [reduxDispatch])
    const onClick = useCallback(() => startCybs(), [startCybs])
    const sendCommand = useCallback(() => {
      startCybs()
      closeModal()
    }, [startCybs])

    const setValue = useCallback(
      (id, value) => {
        setFormState((prev) => set(id, value, prev))
        rerender()
        if (errorMessage) reduxDispatch(removeError('OMISE_PAYMENT'))
      },
      [errorMessage, reduxDispatch, rerender]
    )

    const wrappedDispatch = useCallback(
      (action) => {
        reduxDispatch(action)
        rerender()
      },
      [reduxDispatch, rerender]
    )

    const getState = useCallback(() => localStateRef.current, [])

    const subscribe = useCallback((callback) => {
      callbackListRef.current.push(callback)
      return () => removeFromArray(isEqual(callback), callbackListRef.current)
    }, [])

    const handleConsentValidation = useCallback((val) => setIsDisabledPaymentButton(val), [])
    const handleCheckMethod = useCallback((val) => setIsSelectedMethod(val), [])
    const handleCheckCreditcardRelationShip = useCallback((val) => setIsSelectedCreditCardRelationShip(val), [])

    const customStore = useMemo(() => ({ subscribe, dispatch: wrappedDispatch, getState }), [
      subscribe,
      wrappedDispatch,
      getState,
    ])
    const contextValue = useMemo(() => ({ store: customStore, subscription: null }), [customStore])

    return (
      <ReactReduxContext.Provider value={contextValue}>
        <WrappedComponent
          {...outerProps}
          isModalOpen={isModalOpen}
          toggleModal={handleToggleModal}
          location={location}
          history={history}
          isOpenQuickpayModal={isOpenQuickpayModal}
          toggleQuickpayModal={toggleQuickpayModal}
          closeModal={closeModal}
          form={form}
          setValue={setValue}
          errorMessage={errorMessage}
          state={localState}
          disabled={disabled}
          app={app}
          quickpayDetail={quickpayDetail}
          creditCardPaymentMethod={creditCardPaymentMethod}
          creditCardRelationship={creditCardRelationship}
          isRemoteSelling={isRemoteSelling}
          dispatch={wrappedDispatch}
          getState={getState}
          subscribe={subscribe}
          getCallBackList={() => callbackListRef.current}
          onOpen={onOpen}
          onOpenQuicklink={onOpenQuicklink}
          onResendQuicklink={onResendQuicklink}
          onChangePaymentMethod={onChangePaymentMethod}
          onVerifyPayment={onVerifyPayment}
          onClick={onClick}
          sendCommand={sendCommand}
          isDisabledPaymentButton={isDisabledPaymentButton}
          handleConsentValidation={handleConsentValidation}
          handleCheckMethod={handleCheckMethod}
          handleCheckCreditcardRelationShip={handleCheckCreditcardRelationShip}
        />
      </ReactReduxContext.Provider>
    )
  }
}

export const CreditCardWithLocalStore = addLocalStore(StyledDisplayCreditCardPaymentFormButton)

export default (hoc) => {
  const Component = hoc ? hoc(CreditCardWithLocalStore) : CreditCardWithLocalStore
  return function CreditCardConsentComponent(props) {
    return <Component {...props} />
  }
}
